import { Component, OnInit } from '@angular/core';
import { ContactsService} from '../../services/contacts.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {
  selectedGroup: number = 0;
  selectedGroupID: string;
  groupName: string = "";

  orderedList = -1;

  contact = {
    name: "",
    surname: "",
    idGroup: ""
  }

  editedGroup = {
    id: "",
    title: "",
    idUser: localStorage.getItem("idUser")
  };

  constructor(private contactsService: ContactsService) { 
  }

  ngOnInit() {
    this.contactsService.getContacts();
  }

  selectGroup(i, groupID){
    this.selectedGroup = i;
    this.selectedGroupID = groupID;
  }

  addGroup(){
    this.contactsService.addGroup(this.groupName);
    this.groupName = "";
  }

  addContact(){  
    this.contact.idGroup = this.selectedGroupID;
    this.contactsService.addContact(this.selectedGroup, this.contact);
    this.contact.name = "";
    this.contact.surname = "";
    

  }

  editGroup(i){
    this.editedGroup.id = this.contactsService.contacts[i].id;
    this.editedGroup.title = this.contactsService.contacts[i].title;

    this.selectedGroup = i;
  }

  updateGroup(){
    this.contactsService.updateGroup(this.editedGroup, this.selectedGroup);
  }

  removeGroup(i,id){
    this.contactsService.removeGroup(i, id);
  }
  dropSuccess(i){
    this.orderedList = -1;
    this.contactsService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedList = i;
  }

  dragEnd(){
    this.orderedList = -1;
  }
  
  orderUp(i){
    this.contactsService.orderUp(i);
  }
  orderDown(i){
    this.contactsService.orderDown(i);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contacts/contacts.component.ts